module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box2-4f024802522437318d31259e36705b9e.svg";